import { z } from 'zod/v4';

/**
 * Payment-form rendering mode, mirroring `EPaymentView`
 * (`common/enums/payment-form-view.enum.ts`): an inline `static` form or a
 * modal triggered by a button.
 */
export const paymentViewSchema = z.enum(['static', 'modal']);
